const slHomePage = {
  path: "/index",
  name: "shilinHomePage",
  meta: {
      noCheckLogin: true
    },
    component: () => import("@/pages/shilin/homePage")
};
const slEHomePage = {
  path: "/Eindex",
  name: "slEHomePage",
  meta: {
      noCheckLogin: true
    },
    component: () => import("@/pages/shilin/English")
};
const book = {
  path: "/book",
  name: "shilinbook",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/ticket/ticketlist")
};
const Ticket = {
  path: "/ticketlist",
  name: "shilinTicketlist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/ticket/ticketlist")
};
const eatery = {
  path: "/eaterylist",
  name: "shilineaterylist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/eatery/eaterylist")
};
const shop = {
  path: "/shoplist",
  name: "shilinshoplist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/shop/shoplist")
};
const hotel = {
  path: "/hotellist",
  name: "shilinhotellist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/hotel/hotellist")
};
const introduce = {
  path: "/introduce",
  name: "shilinintroduce",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/shilin/introduce")
}; 
const  strategy= {
  path: "/shilinstrategy",
  name: "shilinstrategy",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/news/newslist")

}; 
const  news= {
  path: "/newslist",
  name: "shilinnewslist",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/news/newslist")
}; 

const shilinRouter = [
  slHomePage,
  slEHomePage,
  introduce,
  strategy,
  Ticket,
  hotel,
  news,
  eatery,
  shop,
  book
];

export default shilinRouter;


// WEBPACK FOOTER //
// ./src/router/shilin.js